





































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { tns } from "tiny-slider/src/tiny-slider";

@Component
export default class ImageGrid extends Vue {
    @Prop({ required: true }) images!: any;

    @Ref() readonly sliderElImages!: HTMLElement;

    slider: any = null;

    viewingImageIndex: number = 0;

    showLightbox: boolean = false;

    mounted() {
        this.initSlider();
    }

    showImage(index: number) {
        this.viewingImageIndex = index;

        this.show();
    }

    show() {
        this.showLightbox = true;
    }

    hide() {
        this.showLightbox = false;
    }

    private initSlider() {
        this.$nextTick(() => {
            // @ts-nocheck
            this.slider = tns({
                container: this.sliderElImages,
                items: 1.1,
                gutter: 24,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: false,
                swipeAngle: false,
                nav: false,
                responsive: {
                    768: {
                        items: 1.2,
                        gutter: 24
                    },
                    1024: {
                        items: 2.2,
                        gutter: 24
                    }
                }
            });
        });
    }

    get gridClass() {
        switch (this.itemCount) {
            case 1:
                return "grid-1";
            case 2:
                return "grid-1 gap-16";
            case 3:
                return "grid-cols-2 gap-16";
            case 4:
                return "grid-cols-3 gap-16";
            default:
                return "grid-cols-3 gap-16";
        }
    }

    get flatImages() {
        let images = [];

        for (let i = 0; i < this.images.length; i++) {
            images.push(this.images[i].url);
        }

        return images;
    }

    get itemCount() {
        return this.images.length;
    }

    get primaryImage() {
        return this.images[0];
    }

    get secondaryImages() {
        return this.images.slice(1, this.images.length);
    }
}
